import { createSelector } from 'reselect';

import StoreProxy from '../storeProxy';

type ReduxState = ReturnType<typeof StoreProxy.getState>;

const selector = (selectors, resultantSelector) =>
  createSelector(selectors, resultantSelector)(StoreProxy.getState());

const wrapSelector = (selectors, resultantSelector) => () =>
  selector(selectors, resultantSelector);

/**
 * @deprecated
 * `wrapDynamicSelector` is deprecated as it directly invokes selectors using `StoreProxy.getState()`,
 * leading to stale data and loss of reactivity.
 *
 * Use `createSelector` from `reselect` directly to define selectors that remain reactive:
 *
 * ```ts
 * export const productLeverageSelector = (product: Product) =>
 *   createSelector([orderMarginSelector], orderMargins => {
 *     if (!product?.id || !orderMargins) return 1;
 *     return orderMargins[product.id]?.leverage || 1;
 *   });
 * ```
 */
const wrapDynamicSelector = selector;

export type { ReduxState };
export { wrapSelector, wrapDynamicSelector };
